<template>
  <div id="trs-menu">
    <div class="mobile-nav" v-if="mobileMode && !tabletMode">
      <a href="#" class="btn btn-lg-edit btn-block btn-danger" v-open-app-mobile
         :url-universal-link="linksAppList.FX_UNIVERSAL_LINK_URL"
         :url-app-store="linksAppList.FX_APPSTORE_URL"
         :url-deep-link="linksAppList.FX_DEEP_LINK_URL"
         :url-android-link="linksAppList.FX_OPENAPP_ANDROID_URL">
        {{ $t('trs.front.header.label.fx.trade.app') }}
      </a>
    </div>

    <div class="mobile-nav" v-if="(!mobileMode && !tabletMode) || tabletMode">
      <a v-if="headerInfo && headerInfo.webtradeExpressUrl" class="btn btn-lg-edit btn-block btn-danger" :href="headerInfo.webtradeExpressUrl">
        {{ $t('trs.front.header.label.fx') }}
      </a>
    </div>

    <ul>
      <li v-for="item in menuItems"
          :class="{ active: item.active }"
          :key="item.id"
          @click="toggleOffCanvasMenu()"
      >
        <router-link :to="item.link" v-if="item.id !== 'performance'">
          <i :class="item.cssClass"></i>
          <span class="menu-label"> {{ $t(item.text) }}</span>
        </router-link>
        <a :href="item.href" v-if="item.id === 'performance' && ((!mobileMode && !tabletMode) || tabletMode)">
          <i :class="'fa fa-fw ' + item.cssClass"></i>
          <span class="menu-label"> {{ $t(item.text) }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * @author HungNS
 */
import {createNamespacedHelpers} from 'vuex';
import $ from "jquery";

const {mapState} = createNamespacedHelpers('leftMenu');
const {mapState: mapHeaderState, mapGetters: mapHeaderGetters} = createNamespacedHelpers('header');

export default {
  data: function () {
    return {}
  },
  computed: {
    ...mapState({
      menuItems: state => state.menuItems
    }),

    ...mapHeaderState({
      headerInfo: state => state.headerInfo,
    }),

    ...mapHeaderGetters(["linksAppList"]),
  },

  methods: {
    toggleOffCanvasMenu() {
      $('#trs-menu, .page').toggleClass('offcanvas');
    }
  }
};
</script>

<style scoped>
.menu-label {
  font-size: 12.2px !important;
}

a {
  text-align: left;
}
</style>

